import { Cell } from '@pelckmans/elementis/components/table';

export default function PrivacyTableCell({ title }: { title: string }) {
  return (
    <Cell density="compact" truncated={false}>
      <Cell.Text title={title} />
    </Cell>
  );
}
